module.exports = __webpack_public_path__ + "img/aspen-winter.eb949e69.png";